import { Injectable } from '@angular/core';

@Injectable()
export class StorageService {

  private localStorage: any;
  private sessionStorage: any;
  private transactionStorage: any;

  constructor() {
    this.localStorage = window['localStorage'];
    this.sessionStorage = window['sessionStorage'];
    this.transactionStorage = {};
  }

  // To save session data ( Removed when browser is closed )
  setSessionItem(key: string, value: string) {
    this.sessionStorage.setItem(key, value);
  }

  // To retrieve session data
  getSessionItem(key: string) {
    return this.sessionStorage.getItem(key);
  }

  // To save permanent data ( Data exists locally until cleared )
  setLocalItem(key: string, value: string) {
    this.localStorage.setItem(key, value);
  }

  // To retreive permanent data
  getLocalItem(key: string) {
    return this.localStorage.getItem(key);
  }

  // To save permanent data ( Data exists locally until cleared )
  setTransactionItem(key: string, value: string) {
    this.transactionStorage[key] = value;
  }

  // To retreive permanent data
  getTransactionItem(key: string) {
    return this.transactionStorage[key];
  }

  // To remove all temporary session data
  clearSession() {
    this.sessionStorage.clear();
  }

  // To remove all data saved by this application
  clearAll() {
    this.sessionStorage.clear();
    this.localStorage.clear();
  }

}



// WEBPACK FOOTER //
// C:/Users/sthanga1/Documents/apicloud-x/apicloud-x/apim-ui-newgen/src/app/core/services/storage.service.ts